module.exports = __webpack_public_path__ + "static/img/fingerpost_goods_2.73d17b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_goods_2.jpg
// module id = tcTX
// module chunks = 0